import React, {FC} from 'react';

import {Plural, Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {
  Skeleton,
  SkeletonColorSchemesEnum,
} from '../../../../../libs/shared/ui/src/components/utility/skeleton';
import {ReportGridItem} from '../../reportViewer/reportGrid';
import {PaddedGridItemDiv, renderMultiSelectDropdown, StyledLabelDiv} from './common';

/*
 * Props.
 */

export interface ExportEventTypesInputProps {
  availableEventTypes: ReadonlyArray<string>;
  selectedEventTypes: ReadonlyArray<string>;
  setEventTypes: (arg: ReadonlyArray<string>) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const ExportEventTypesInput: FC<ExportEventTypesInputProps> = ({
  availableEventTypes,
  selectedEventTypes,
  setEventTypes,
  isLoading,
  isDisabled,
}) => {
  if (isLoading) {
    return renderLoadingState();
  }

  return (
    <PaddedGridItemDiv>
      {renderLabel()}

      <DropdownBoxCoordinator
        shouldDisablePadding
        isDisabled={isDisabled}
        value={renderEventsHeader(availableEventTypes.length, selectedEventTypes.length)}
        renderDropdown={(popoverProps) =>
          renderMultiSelectDropdown(popoverProps, availableEventTypes, selectedEventTypes, setEventTypes)
        }
      />
    </PaddedGridItemDiv>
  );
};

/*
 * Helpers.
 */

function renderLabel() {
  return (
    <StyledLabelDiv>
      <Trans id="analytics-export-confirmation-label-events">Events</Trans>
    </StyledLabelDiv>
  );
}

function renderEventsHeader(availableEventsCount: number, selectedEventsCount: number) {
  if (selectedEventsCount === availableEventsCount) {
    return <Trans id="analytics-export-confirmation-select-all-events-header">All events</Trans>;
  }

  return (
    <Plural
      id="analytics-export-confirmation-select-events-header"
      value={selectedEventsCount}
      one="1 event type"
      other="# event types"
    />
  );
}

function renderLoadingState() {
  return (
    <PaddedGridItemDiv>
      {renderLabel()}
      <ReportGridItem>
        <Skeleton width="100%" height="26px" borderRadius="6px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </ReportGridItem>
    </PaddedGridItemDiv>
  );
}
